module.exports = __webpack_public_path__ + "static/img/logo-med.361f8db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-med.png
// module id = 61
// module chunks = 2